import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTracking } from "react-tracking";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import EndUserEditorialPolicyRoutes from "./EndUserEditorialPolicyRoutes";

const EndUserEditorialPolicyRoot = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Client Search Text",
      page: "Client EditorialPolicy Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );
  return (
    <div>
      <Track>
        <EndUserEditorialPolicyRoutes />
      </Track>
    </div>
  );
};

export default EndUserEditorialPolicyRoot;
